import React from "react";
import Lottie from "lottie-react";
import speakingAnim from "./speaking.json";

export default function VoiceWavesLottie({ visualMode, isDesktop }) {
  const isSpeaking = visualMode === "speaking";
  const isListening = visualMode === "listening";

  if (!isSpeaking && !isListening) return null;

  return (
    <div
      style={{
        width: '100%',
        height: 300,
        margin: "20px auto 0",
        opacity: isSpeaking ? 1 : 0.25,
        transition: "opacity 0.3s ease",
      }}
    >
      <Lottie
        key={visualMode}
        animationData={speakingAnim}
        loop
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}
